import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ClockIcon, UsersIcon, BookOpenIcon, StethoscopeIcon } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
const differentials = [{
  icon: ClockIcon,
  text: 'Respeta el ritmo del niño'
}, {
  icon: UsersIcon,
  text: 'Se adapta a cada familia'
}, {
  icon: BookOpenIcon,
  text: 'No medicaliza el proceso'
}, {
  icon: StethoscopeIcon,
  text: 'No sustituye consejo profesional'
}];
export function DifferentialSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <SectionWrapper background="cream" data-id="element-45">
      <div ref={ref} className="grid md:grid-cols-2 gap-12 items-center" data-id="element-46">
        {/* Content */}
        <div data-id="element-47">
          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-6" data-id="element-48">
            No es un truco rápido, es un método educativo
          </h2>

          <p className="text-navy/70 text-lg mb-8 leading-relaxed" data-id="element-49">
            Noches Secas no promete soluciones mágicas ni resultados inmediatos.
            Es un método pensado para acompañar un proceso natural de
            aprendizaje, respetando los tiempos de cada niño y cada familia.
          </p>

          <ul className="space-y-4" data-id="element-50">
            {differentials.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            delay: 0.2 + index * 0.1
          }} className="flex items-center gap-4" data-id="element-51">
                <span className="flex-shrink-0 w-10 h-10 rounded-full bg-soft-blue/10 flex items-center justify-center" data-id="element-52">
                  <item.icon className="w-5 h-5 text-soft-blue" data-id="element-53" />
                </span>
                <span className="text-navy font-medium" data-id="element-54">{item.text}</span>
              </motion.li>)}
          </ul>
        </div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={isInView ? {
        opacity: 1,
        x: 0
      } : {}} transition={{
        duration: 0.6
      }} className="flex justify-center" data-id="element-55">
          <img src="https://cdn.magicpatterns.com/uploads/j2JTZxKqVDhyZhGP1NGYEA/5._.png" alt="Sello de garantía dorado con iconos de calidad del método" className="w-full max-w-md h-auto" data-id="element-56" />
        </motion.div>
      </div>
    </SectionWrapper>;
}